import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.2 2.572h-2.272A1.964 1.964 0 0 0 13.964 1h-3.928A1.964 1.964 0 0 0 8.11 2.572H5.8A1.666 1.666 0 0 0 4.143 4.23v17.112A1.666 1.666 0 0 0 5.8 23h12.398a1.666 1.666 0 0 0 1.658-1.658V4.23a1.665 1.665 0 0 0-1.658-1.658m-8.164 0h3.928a.393.393 0 0 1 0 .785h-3.928a.393.393 0 1 1 0-.785m8.25 18.77a.086.086 0 0 1-.087.087H5.801a.086.086 0 0 1-.087-.087V4.23a.087.087 0 0 1 .087-.087h2.671a1.97 1.97 0 0 0 1.572.786h3.928a1.97 1.97 0 0 0 1.572-.786h2.67a.086.086 0 0 1 .087.087z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.928 8.072h-4.714a.785.785 0 1 0 0 1.571h4.714a.786.786 0 1 0 0-1.571M8.071 8.072a.786.786 0 1 0 0 1.571.786.786 0 0 0 0-1.571M15.928 12h-4.714a.786.786 0 0 0 0 1.572h4.714a.786.786 0 1 0 0-1.572M8.071 12a.786.786 0 1 0 0 1.572.786.786 0 0 0 0-1.572M15.928 15.929h-4.714a.786.786 0 0 0 0 1.571h4.714a.786.786 0 1 0 0-1.571M8.071 15.929a.786.786 0 1 0 0 1.572.786.786 0 0 0 0-1.572"
    }, null, -1)
  ]))]))
}
export default { render: render }